<script>
import { apiOrganPUserGetOrganModelTree, apiOrganPUserGetProjectModelTree, apiOrganPUserGetProjectModelCommit, apiOrganPUserDeleteProjectModelCommit } from '@/api/manage'
import { PROJECT_TYPE } from '@/enum'
import selectProjectAuth from './selectProjectAuth.vue'
export default {
  name: 'ProjectAuth',
  components: { selectProjectAuth },
  props: {
    orgUserUuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      PROJECT_TYPE,
      searchForm: { orgOrganId: '' },
      treeData: [],
      idArr: [],
      defaultProps: {
        children: 'children',
        label: 'organName'
      },
      treeDataProject: [],
      idArrProject: [],
      defaultPropsProject: {
        children: 'children',
        label: 'projectName',
        disabled: (data, node) => {
          return data.readOnly
        }
      },
      visibleProject: false,
      loading: false
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getTree()
  },
  methods: {
    /**
     * 组织树数据
     */
    getTree() {
      apiOrganPUserGetOrganModelTree({ orgUserUuid: this.orgUserUuid }).then((d) => {
        this.treeData = d.data
        if (d.data.length === 0) return false
        //
        this.treeData.forEach((item) => {
          this.idArr.push(item.orgOrganId)
        })
        this.$nextTick(() => {
          this.$refs.tree.setCurrentNode(d.data[0].children[0]) // 默认第一个公司
          this.searchForm.orgOrganId = d.data[0].children[0].orgOrganId // 默认第一个公司
        })
        this.currentTreeChange(d.data[0].children[0])// 默认第一个公司
      })
    },
    /**
     * 项目树数据
     */
    getTreeProject() {
      this.loading = true
      apiOrganPUserGetProjectModelTree({
        orgOrganId: this.searchForm.orgOrganId,
        orgUserUuid: this.orgUserUuid
      }).then((d) => {
        this.loading = false
        this.treeDataProject = d.data
        if (d.data.length === 0) return false
        this.treeDataProject.forEach((item) => {
          this.idArrProject.push(item.busProjectId)
        })
        this.$nextTick(() => {
          this.$refs.treeProject.setCurrentNode(d.data[0])
        })
      })
    },
    // 组织选中当前节点
    currentTreeChange(row, node) {
      this.searchForm.orgOrganId = row.orgOrganId
      this.busOrganObj = row
      this.getTreeProject()
    },
    currentTreeChangeProject() {},
    /**
     * 保存项目授权
     * @param val
     */
    changeProject(val) {
      this.$confirm('是否保存项目授权', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const load = this.$load()
          apiOrganPUserGetProjectModelCommit({
            orgUserUuid: this.orgUserUuid,
            ...val
          })
            .then((d) => {
              load.close()
              this.$message.success('修改成功！')
              this.getTree()
              this.visibleProject = false
            })
            .catch((e) => {
              load.close()
              this.$errorHandle(e)
            })
        })
        .catch(() => {
          this.$message.info('取消修改！')
        })
    },
    /**
     * 删除项目
     * @param node
     * @param data
     */
    remove(node, data) {
      this.$confirm(`是否删除项目:${data.projectName}?`, '提示', {
        type: 'warning'
      }).then(() => {
        const load = this.$load()
        apiOrganPUserDeleteProjectModelCommit({
          id: data.busProjectId,
          orgUserUuid: this.orgUserUuid
        }).then((d) => {
          this.$message.success('删除成功!')
          load.close()
          this.getTreeProject()
        }).catch((e) => {
          load.close()
          this.$errorHandle(e)
        })
      }).catch(() => {
        this.$message.info('已取消删除!')
      })
    },
    addAuth() {
      this.visibleProject = true
      console.log(this.visibleProject)
    }
  }
}
</script>

<template>
  <div class="project-auth">
    <el-button v-permission="['112030201101303']" type="primary" class="project-auth-add" @click="addAuth">添加</el-button>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card shadow="never" class="project-auth-card" :body-style="{ height: '100%', overflow: 'auto' }">
          <template #header>
            <div class="clearfix">组织架构</div>
          </template>
          <el-tree
            ref="tree"
            class="filter-tree"
            :data="treeData"
            :props="defaultProps"
            node-key="orgOrganId"
            highlight-current
            style="margin-top: 10px; margin-bottom: 55px"
            :default-expanded-keys="idArr"
            @current-change="currentTreeChange"
          >
            <template #default="{ node, data }">
              <div>
                <el-tag size="small" :style="{ color: '#333', background: '#EDEDED', borderColor: '#EDEDED' }">
                  {{ data.organTypeName }}
                </el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="data.organName"
                  placement="top-start"
                >
                  <span class="dib m-organName">{{ data.organName }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" class="project-auth-card" :body-style="{ height: '100%', overflow: 'auto' }">
          <template #header>
            <div class="clearfix">项目</div>
          </template>
          <el-tree
            ref="treeProject"
            class="filter-tree"
            :data="treeDataProject"
            :props="defaultPropsProject"
            node-key="busProjectId"
            highlight-current
            style="margin-top: 10px;margin-bottom: 55px;"
            :default-expanded-keys="idArrProject"
            @current-change="currentTreeChangeProject"
          >
            <template #default="{ node, data }">
              <div class="custom-tree-node" :class="{ isOnly: data.readOnly }">
                <span>
                  <el-tag size="small" :style="{ color: '#333', background: '#EDEDED', borderColor: '#EDEDED' }">
                    {{ PROJECT_TYPE[data.projectTypeCode] }}
                  </el-tag>
                  <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
                    <span class="dib m-organName">{{ node.label }}</span>
                  </el-tooltip>
                </span>
                <span v-permission="['112030201101304']" class="edit" :class="{ on: node.isCurrent && data.readOnly !== 1 }">
                  <el-tooltip
                    effect="dark"
                    content="删除"
                    placement="top"
                  >
                    <el-button type="text" size="small" @click.stop="() => remove(node, data)">
                      <i class="el-icon-delete" />
                    </el-button>
                  </el-tooltip>
                </span>
              </div>
            </template>
          </el-tree>
        </el-card>
      </el-col>
    </el-row>
    <select-project-auth
      v-model="visibleProject"
      :org-user-uuid="orgUserUuid"
      @submit="changeProject"
    />
  </div>
</template>

<style scoped lang="scss">
.project-auth{
  position: relative;
  height: 100%;
  ::v-deep{
    .gp-row,.gp-col{
      height: 100%;
    }
  }
}
.project-auth-add{
  position: absolute;
  top: -53px;
  right: 0;
}
.project-auth-card{
  height: 100%;
}
.m-organName {
  font-size: 14px;
  max-width: 240px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 5px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .edit {
    //opacity: 0;
    transition: 300ms;
    visibility: hidden;

    &.on {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
